<app-display-card>
  <div
    class="row justify-content-between align-items-center"
    (click)="collapse = !collapse"
  >
    <div class="col-6">
      <h3>IRS Background Validation</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{ collapse ? 'up' : 'down' }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  @if (businessComplianceSettingForms) {
    <div class="inner-panel rounded" [(ngbCollapse)]="collapse">
      <div class="row align-items-center mx-2">
        <div class="row">
          <div class="col-3"></div>
          <div class="col-3 d-flex flex-column align-items-center">
            <label>Global</label>
          </div>
        </div>
        @if (!collapse) {
          @for (
            item of businessVerifiedCompanyBackgroundChecksMap
              | keyvalue: keyValuePairDefaultOrder;
            track item
          ) {
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">{{ item.key }}</label>
              </div>
              @for (form of businessComplianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    @if (item.value.inputType === 'Select') {
                      <div class="form-group">
                        <select
                          class="form-select"
                          formControlName="{{ item.value.controlName }}"
                        >
                          @for (
                            option of item.value.selectOptions
                              | keyvalue: keyValuePairDefaultOrder;
                            track option
                          ) {
                            <option [ngValue]="getOptionValue(option)">
                              {{ option.key }}
                            </option>
                          }
                        </select>
                      </div>
                    }
                    @if (item.value.inputType === 'Checkbox') {
                      <div class="form-check-group mt-0">
                        <input
                          id="bvCompanyBackgroundChecks_{{
                            item.value.controlName +
                              '_' +
                              form.controls.id.value
                          }}"
                          type="checkbox"
                          class="form-check-input"
                          formControlName="{{ item.value.controlName }}"
                        />
                        <label
                          for="bvCompanyBackgroundChecks_{{
                            item.value.controlName +
                              '_' +
                              form.controls.id.value
                          }}"
                          class="form-check-label"
                          >{{ item.value.checkBoxLabel }}</label
                        >
                      </div>
                    }
                  </form>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</app-display-card>
